var _path, _g, _path2, _path3, _ellipse, _g2, _ellipse2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 34 39"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__a",
    width: 32,
    height: 22,
    x: 2,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.23 18.662c-.334.138-1.462.63-1.764.8-4.355 2.37-15.084 14.83-15.1 16.861v.138c.207 1.078 18.23 2.37 23.11.878.334-.108 1.478-.57 1.812-.708 3.814-1.615 6.103-5.23 6.103-9.015 0-1.308-.27-2.631-.842-3.908-1.669-3.677-5.404-5.877-9.298-5.877-1.351 0-2.718.262-4.037.815"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__b)",
    d: "M33.423 17.846H2.366v21h31.057z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__c",
    width: 26,
    height: 37,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.053 3.63A11.6 11.6 0 0 0 1.542 7.4c-.16.385-.716 1.754-.827 2.154C.223 11.23 0 14.139 0 17.446c0 7.246 1.001 16.415 2.146 18.693.127.246.238.384.365.461 2.273 1.739 17.5-13.108 20.79-18.185.429-.661.794-1.415 1.112-2.415.429-1.385.652-2.77.652-4.139 0-4.784-2.67-9.107-7.566-11.03A12.7 12.7 0 0 0 13.573 0h-.635C9.6 0 6.389 1.323 4.068 3.646"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_svg__c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__d)",
    d: "M10.351-11.958-19.511 22.49 14.7 50.278 44.564 15.83z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__f",
    width: 16,
    height: 24,
    x: 2,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.716,
    cy: 11.876,
    fill: "url(#logo_svg__e)",
    rx: 6.716,
    ry: 11.876,
    transform: "matrix(.96199 .27857 -.2908 .95512 6.716 3.388)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F84CB",
    d: "M15.216 6.449c-4.193 2.887-8.182 14.419-9.652 19.824l2.322 2.992 11.28-10.285z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__h",
    width: 19,
    height: 13,
    x: 12,
    y: 22,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.366,
    cy: 9.375,
    fill: "url(#logo_svg__g)",
    rx: 5.366,
    ry: 9.375,
    transform: "matrix(.44892 .8587 -.92043 .4533 27.384 19.44)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#287ABF",
    d: "M30.194 25.86c-4.016-.78-13.05 3.248-17.066 5.36l-.502 2.922 12.297.73z",
    opacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 11.8758 -6.71629 0 6.716 11.876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 9.37489 -5.36619 0 5.366 9.375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 3.662,
    x2: 34.703,
    y1: 29.097,
    y2: 29.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2A97D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2577BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__d",
    x1: -2.956,
    x2: 20.887,
    y1: 34.816,
    y2: 5.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#41C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })))));
};
export default SvgLogo;